import { Wrap } from './styles';

import React, { useEffect, useRef } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';

const CAR_VERTICAL_MARGIN = 16;
const EASING_FACTOR = 0.12;

const SmoothCar = () => {
  const imageRef = useRef(null);

  useEffect(() => {
    const image = imageRef.current;
    const figure = image.parentElement;
    let currentOffset = 0;
    let targetOffset = 0;
    let frameId = null;

    const clamp = value => Math.min(Math.max(value, 0), 1);

    const animate = () => {
      const difference = targetOffset - currentOffset;

      currentOffset += difference * EASING_FACTOR;
      image.style.transform = `translate3d(0, ${currentOffset}px, 0)`;

      if (Math.abs(difference) > 0.1) {
        frameId = window.requestAnimationFrame(animate);
      } else {
        currentOffset = targetOffset;
        image.style.transform = `translate3d(0, ${currentOffset}px, 0)`;
        frameId = null;
      }
    };

    const updateTarget = () => {
      const container = figure.parentElement;
      const rect = container.getBoundingClientRect();
      const progress = clamp(
        (window.innerHeight - rect.top) / (window.innerHeight + rect.height)
      );
      const travelDistance = Math.max(
        0,
        container.offsetHeight - image.offsetHeight - CAR_VERTICAL_MARGIN * 2
      );

      targetOffset = progress * travelDistance;

      if (frameId === null) {
        frameId = window.requestAnimationFrame(animate);
      }
    };

    window.addEventListener('scroll', updateTarget, { passive: true });
    window.addEventListener('resize', updateTarget);
    updateTarget();

    return () => {
      window.removeEventListener('scroll', updateTarget);
      window.removeEventListener('resize', updateTarget);

      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }, []);

  return (
    <figure className="car">
      <img ref={imageRef} src="/img/car.png" alt="Carro andarilho" />
    </figure>
  );
};

export default _props => (
  <ScrollableAnchor id="servicos">
    <Wrap>
      <h2>
        <div>Descrição das nossas</div> <div>Eco-Lavagens Automotivas</div>
      </h2>
      <div className="courtain" />
      <div className="container">
        <div>
          <h1>1</h1>
          <h2>Lavagem Eco-Basic</h2>
          <p>
            <strong>Duração:</strong> aproximadamente 1h para carros pequenos
            (P) e médios (M) e até 1h20min para carros grandes (G) e GG*.
            <br />
            <br />
            Limpeza de caixa de rodas; Limpeza dos pneus e jantes, com aplicação
            de condicionador de borracha; Limpeza externa de lataria e entre
            portas com Eco Lavagem.
          </p>
        </div>
        <div>
          <h1>2</h1>
          <h2>Lavagem Eco-Plus</h2>
          <p>
            <strong>Duração:</strong> aproximadamente 1h20min para carros P e M
            e até 1h40min para carros G e GG.
            <br />
            <br />
            Tudo da Lavagem Eco-Basic mais limpeza interna de painel com
            microfibra e pincéis de detalhamento; Aspiração interna completa:
            bancos, carpetes e porta-malas.
          </p>
        </div>
        <div>
          <h1>3</h1>
          <h2>Lavagem Eco-Master</h2>
          <p>
            <strong>Duração:</strong> aproximadamente 2h para carros P e M e até
            3h para carros G e GG.
            <br />
            <br />
            Tudo da Lavagem Eco-Plus mais limpeza detalhada de painel, portas,
            colunas e câmbio com produto APC sanitizante e antibactericida,
            utilizando microfibras e pincéis de detalhamento; após a limpeza,
            aplicação de condicionador de plásticos com proteção UV.
          </p>
        </div>
        <div>
          <h1>4</h1>
          <h2>Lavagem Eco-Premium</h2>
          <p>
            <strong>Duração:</strong> aproximadamente 3h para carros P e M e até
            4h para carros G e GG.
            <br />
            <br />
            Tudo da Lavagem Eco-Master mais descontaminação de pintura com Clay
            Bar para retirada de sujidades impregnadas, como piche e demais
            contaminações; Aplicação de Cera Premium com proteção de até 4
            meses; Revitalização de plásticos externos com aplicação de
            condicionador e protetor UV; Descontaminação e cristalização dos
            vidros; Grátis: aerosol granada, fragrância carro novo, para
            higienização do ar-condicionado (recomendamos trocar o filtro de
            ar).
          </p>
        </div>
        <SmoothCar />
      </div>
      <p className="products-note">
        * Para ver o tamanho do seu carro,{' '}
        <a href="/simulador">acesse o nosso simulador</a>.
      </p>
    </Wrap>
  </ScrollableAnchor>
);
